import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cf93b7d2")

_pushScopeId("data-v-cf93b7d2")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "dt-open-api-page-bar clearfix" }, [
  /*#__PURE__*/_createVNode("span", { class: "dt-open-api-page-bar-title" }, " 数据互操作数据管理 ")
], -1)
const _hoisted_2 = { class: "dt-open-api-data-push-content" }
const _hoisted_3 = { class: "dt-open-api-data-push-state" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存 ")
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "dt-open-api-data-push-tip" }, [
  /*#__PURE__*/_createTextVNode("说明：基础数据变更会以HTTP POST方式请求应用的数据推送地址通知第三方，请求会以query的形式附带参数eventId=事件id&eventType=事件类型，第三方接收到事件通知以后根据事件类型获取数据自行更新数据即可。 "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 如：https://www.demo.com/dataEvent/notify?eventId=xxxxxxxxxxxxxxxxxxxxxxx&eventType=user_basic_info_updated")
], -1)
const _hoisted_6 = { class: "dt-open-api-api-content" }
const _hoisted_7 = { class: "dt-open-api-api-table" }
const _hoisted_8 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "事件说明"),
    /*#__PURE__*/_createVNode("th", null, "eventId"),
    /*#__PURE__*/_createVNode("th", null, "eventType")
  ])
], -1)
const _hoisted_9 = { style: {"color":"unset","cursor":"unset"} }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        ref: "formItemRef",
        model: _ctx.formItem,
        rules: _ctx.rules,
        "label-width": "130px"
      }, {
        default: _withId(() => [
          (_ctx.application.dataPushUrl)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "审核状态："
              }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_3, _toDisplayString(_ctx.application.dataPushExamineState === 0 ? '未审核':_ctx.application.dataPushExamineState === 1 ? '审核通过':'审核未通过'), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "数据推送地址：",
            prop: "dataPushUrl",
            class: "dt-open-api-data-push-row"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formItem.dataPushUrl,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.formItem.dataPushUrl = $event)),
                type: "text",
                placeholder: "请输入数据推送地址",
                style: {"margin-right":"20px"}
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.saveDataPush
              }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("table", null, [
            _hoisted_8,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.eventList, (item) => {
              return (_openBlock(), _createBlock("tr", {
                key: item.eventId
              }, [
                _createVNode("td", _hoisted_9, _toDisplayString(item.desc), 1),
                _createVNode("td", null, _toDisplayString(item.eventId), 1),
                _createVNode("td", null, _toDisplayString(item.eventType), 1)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ])
  ]))
})